var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconImport = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M21.3,26.3H5.4c-1.2,0-2.2-1-2.2-2.2v-7.9 M26.8,16.2v7.9c0,1.2-1,2.2-2.2,2.2h-3.2 M21.4,10.8h3.2c1.2,0,2.2,1,2.2,2.2v3.2 M3.2,16.2v-3.3c0-1.2,1-2.2,2.2-2.2h3.2" }),
            React.createElement("g", null,
                React.createElement("path", { d: "M11,16.2l4,4l4-4" }),
                React.createElement("path", { d: "M15,20.2V5.3" })))));
});
export default IconImport;
//# sourceMappingURL=IconImport.js.map